var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/request-holiday-new.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-a29dc76c!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/request-holiday-new.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RequestHolidayNew.vue
// module id = 1338
// module chunks = 1